import config from 'config';
import moment from 'moment-timezone';

const baseURL = config.apiPath;

const processFetch = async (res) => {
  if (res.headers.get('Content-Type').includes('application/zip')) {
    const createAt = moment().format('DD-MM-YYYY');
    let fileName = `Download_${createAt}.zip`;
    const contentDisposition = res.headers.get('Content-Disposition');
    if (contentDisposition) {
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = filenameRegex.exec(contentDisposition);
      if (matches != null && matches[1]) {
        fileName = matches[1].replace(/['"]/g, '');
      }
    }
    if (window.URL && document) {
      const a = document.createElement('a');
      const blob = await res.blob();
      a.href = window.URL.createObjectURL(blob);
      a.download = fileName;
      a.click();
      return {};
    }
  }
  return Promise.all([res.ok, res.json()])
    .then(([ok, response]) => {
      if (!ok) {
        return Promise.reject(response);
      }
      return { data: response };
    });
};

export default {
  get: async url => {
    return fetch(`${baseURL}${url}`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        //  'x-access-token': '3y3eOjYqQJyY21dyfY7WqWUwGG9lQJMj'
      },
    }).then(processFetch);
  },
  post: async (url, body = {}) => {
    return fetch(`${baseURL}${url}`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        // TODO: PLEASE REMOVE THIS BEFORE DEPLOYING
        //  'x-access-token': '3y3eOjYqQJyY21dyfY7WqWUwGG9lQJMj'
      },
      body: JSON.stringify(body),
    }).then(processFetch);
  },
  put: async (url, body = {}) => {
    return fetch(`${baseURL}${url}`, {
      method: 'PUT',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        //  'x-access-token': '3y3eOjYqQJyY21dyfY7WqWUwGG9lQJMj'
      },
      body: JSON.stringify(body),
    }).then(processFetch);
  },
  delete: async (url, body = {}) => {
    return fetch(`${baseURL}${url}`, {
      method: 'DELETE',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        //  'x-access-token': '3y3eOjYqQJyY21dyfY7WqWUwGG9lQJMj'
      },
      body: JSON.stringify(body),
    }).then(processFetch);
  }
};



// WEBPACK FOOTER //
// ./src/utils/api.js